/**
 * Debug logging utilities that respect environment settings
 * Only logs in non-production environments
 *
 * Uses REACT_APP_ENABLE_DEBUG_LOGS instead of NODE_ENV because:
 * - NODE_ENV is always 'production' during npm run build (even for staging)
 * - We want logs enabled for staging but disabled for production
 */

// Build-time flag - will be inlined as true/false by webpack
const DEBUG_ENABLED = process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true' || process.env.NODE_ENV === 'development';

// Include build environment info to force different hashes
const BUILD_ENV = process.env.REACT_APP_ENABLE_DEBUG_LOGS ? 'staging' : 'production';

export const debugLog = (...args: any[]) => {
  if (DEBUG_ENABLED) {
    console.log(...args);
  }
};

export const debugError = (...args: any[]) => {
  if (process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true' || process.env.NODE_ENV === 'development') {
    console.error(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true' || process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
};

// Always log errors (for monitoring), regardless of environment
export const errorLog = (...args: any[]) => {
  console.error(...args);
};

// Version marker to force rebuild
export const DEBUG_UTILS_VERSION = '2.0';
